<template>
<div :key="forceUpdateCounter">
  <HeaderControls :myWeek='true' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate' :namespace="namespace"/>
  <div class="container-fluid">
    <DeliverableList :filterQuery="filterQuery" :myWeek="true" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate' :namespace="namespace" />
  </div>
  </div>
</template>
<script>
import DeliverableList from "../components/deliverables/List";
import HeaderControls from "../components/common/HeaderControls";

export default {
  data() {
    return {
    	namespace:"",
      filterQuery: {
        query: "",
        filterByDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: []
      },
      expandAll: !this.isMobile()
    }
  },
  computed: {
    forceUpdateCounter() {
      return this.$store.state.deliverables.forceUpdateCounter
    }
  },
  components: {
    DeliverableList,
    HeaderControls
  },
  methods: {
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    }
  }
};
</script>